import ReportIcon from './component'

export default ReportIcon
